export function lookupRelationsByEids(eids) {
  return eids.map((eid) => findRelationByEid(eid)).filter((el) => el)
}

export function findRelationByEid(eid) {
  const relation = document.querySelector(`[data-eid="${eid}"]`)
  if (!relation) { return undefined; }

  return parseRelation(relation, eid)
}

export function parseRelation(relation, eid) {
  return {
    eid: eid || relation.dataset.eid,
    abbr: relation.querySelector('[data-field-name="abbr"]')?.value,
    independentAbbr: relation.querySelector('[data-field-name="independent_abbr"]')?.value,
    independentVariable: relation.querySelector('[data-field-name="independent_variable"]')?.value,
    dependentAbbr: relation.querySelector('[data-field-name="dependent_abbr"]')?.value,
    dependentVariable: relation.querySelector('[data-field-name="dependent_variable"]')?.value,
    moderatorAbbr: relation.querySelector('[data-field-name="moderator_abbr"]')?.value,
    moderatorVariable: relation.querySelector('[data-field-name="moderator_variable"]')?.value,
    mediatorAbbrs: Array.from(relation.querySelectorAll('[data-field-name="mediator_abbr"]')).map((input) => input.value),
    mediatorVariables: Array.from(relation.querySelectorAll('[data-field-name="mediator_variable"]')).map((input) => input.value),
    supported: relation.querySelector('[data-field-name="supported"]')?.value,
    impact: relation.querySelector('[data-field-name="impact"]')?.value,
    partialFull: relation.querySelector('[data-field-name="partial_full"]')?.value,
    tab: findTab(relation)
  }
}

export function findTab(element) {
  const tabContent = element.closest('.tab-content')
  const tabLink = document.querySelector(`[data-tab="${tabContent.id}"] span`)

  return { name: tabLink.innerText, id: tabContent.id }
}
